
















import { defineComponent, provide, SetupContext, onMounted, onBeforeUnmount } from '@vue/composition-api';
import { useStatusBoardStoreModule, StatusBoardStoreModuleKey } from '@/modules/statusBoard/store';
import { useStatusBoardRoomModule } from '@/modules/statusBoard/room';
import TdContainer from '@/layouts/TdContainer.vue';
import TdRow from '@/layouts/TdRow.vue';
import TdCol from '@/layouts/TdCol.vue';
import StatusBoardCharacter from '@/components/statusBoard/StatusBoardCharacter.vue';
import StatusBoardEditToolbar from '@/components/statusBoard/StatusBoardEditToolbar.vue';

export default defineComponent({

  components: { TdContainer, TdRow, TdCol, StatusBoardCharacter, StatusBoardEditToolbar },

  setup (props: {}, ctx: SetupContext) {

    const storeModule = useStatusBoardStoreModule();
    const roomModule = useStatusBoardRoomModule();
    provide(StatusBoardStoreModuleKey, storeModule);

    onMounted(async () => {
      const room = await roomModule.fetch(ctx.root.$route.params['roomId'] as string);
      if (!room.roomId) {
        ctx.root.$router.push('/statusboard');
        return;
      }
      storeModule.initialize(room);
      storeModule.subscribe();
    });

    onBeforeUnmount(() => {
      storeModule.unsubscribe();
    });

    return {
      characters: storeModule.characters
    };
  }
});
